"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.link = exports.content = exports.icon = exports.banner = void 0;

var _react = require("@emotion/react");

var _chromaJs = _interopRequireDefault(require("chroma-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: right;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: fit-content;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 16px;\n  background: ", ";\n  color: ", " !important;\n  border-radius: 8px;\n  position: relative;\n  display: flex;\n  margin: 8px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function backgroundColourVariantPicker(variant, theme) {
  var _theme$colors;

  switch (variant) {
    case 'info':
      return (0, _chromaJs["default"])(theme.colors.info).set('lch.c', '*0.9').set('lab.l', '*2.2').hex();

    case 'success':
      return (0, _chromaJs["default"])(theme.colors.success).set('lch.c', '*0.4').set('lab.l', '*2.08').hex();

    case 'error':
      return (0, _chromaJs["default"])(theme.colors.danger).set('lch.c', '*0.4').set('lab.l', '*2.5').hex();

    case 'warning':
      return (0, _chromaJs["default"])(theme.colors.warning).set('lch.c', '*0.4').set('lab.l', '*2.2').hex();

    default:
      return theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.neutral[100];
  }
}

function textColourVariantPicker(variant, theme) {
  var _theme$colors2, _theme$colors3, _theme$colors4, _theme$colors5, _theme$colors6;

  switch (variant) {
    case 'info':
      return theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.info;

    case 'error':
      return theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : _theme$colors3.danger;

    case 'success':
      return theme === null || theme === void 0 ? void 0 : (_theme$colors4 = theme.colors) === null || _theme$colors4 === void 0 ? void 0 : _theme$colors4.success;

    case 'warning':
      return theme === null || theme === void 0 ? void 0 : (_theme$colors5 = theme.colors) === null || _theme$colors5 === void 0 ? void 0 : _theme$colors5.warning;

    default:
      return theme === null || theme === void 0 ? void 0 : (_theme$colors6 = theme.colors) === null || _theme$colors6 === void 0 ? void 0 : _theme$colors6.neutral[500];
  }
}

var banner = function banner(variant) {
  return function (theme) {
    return (0, _react.css)(_templateObject(), backgroundColourVariantPicker(variant, theme), textColourVariantPicker(variant, theme));
  };
};

exports.banner = banner;
var icon = (0, _react.css)(_templateObject2());
exports.icon = icon;
var content = (0, _react.css)(_templateObject3());
exports.content = content;
var link = (0, _react.css)(_templateObject4());
exports.link = link;